import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { Button, Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";
import { TbDrone } from "react-icons/tb";
import { MdSettingsRemote } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import edit from "../../../picture/editing.png";
import cancel from "../../../picture/cancel.png";
import { BiEdit } from "react-icons/bi";
import { FcDocument } from "react-icons/fc";
import check from "../../../picture/check.png";
import AuthService from "../../../services/auth.service";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import { MdOutlinePayments } from "react-icons/md";
import PaginationS from "../../admin/Pagination";
import { cleanDigitSectionValue } from "@mui/x-date-pickers/internals/hooks/useField/useField.utils";
import Static_modal from "../etc/Static_modal";
//Steps
import User_Drone_Status from "../../../Style_Component/Steps/User_Drone_Status";
//Prime
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";

//icon
import { AiFillDollarCircle } from "react-icons/ai";
import { GiDeliveryDrone } from "react-icons/gi";
import { FaUserAstronaut } from "react-icons/fa";
import { MdDateRange } from "react-icons/md";
import { FaRegFileLines } from "react-icons/fa6";
import fileicon from "../../../picture/file-icon.png";
import edits from "../../../picture/edit.gif";
import disconnect from "../../../picture/disconnected.png";
// import docgif from "../../picture/document-office.gif";
import docgif from "../../../picture/investigation.gif";
import { useLanguage } from "../../../Language/LanguageContext";
function StatusDrone() {
  const { t, changeLanguage, language, fontFamily } = useLanguage();
  let Navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isReloadComponent, setIsReloadComponent] = useState(false);
  const [remoteDrone, setRemoteDrone] = useState([]);
  const [selectedItemsA, setSelectedItemsA] = useState([]);
  const [selectedItemsB, setSelectedItemsB] = useState([]);
  const [currnetChoosing, setCurrentChoosing] = useState();
  const [checkEditReason, setCheckEditReason] = useState(false);
  const [comment, setComment] = useState([""]);
  const [droneidPay, setdroneidPay] = useState("");
  const [ShowPayment, setShowPayment] = useState(false);
  const [connectrid, setconnectrid] = useState(false);
  const [droneids, setDroneids] = useState("");
  const [remoteids, setRemoteids] = useState("");
  const [showConfirmConnect, setShowConfirmConnect] = useState(false);
  const [showRemoveConnect, setShowRemoveConnect] = useState(false);
  const [showRemoveRemote, setShowRemoveRemote] = useState(false);
  const [shownoregisdrone, setShownoregisdrone] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };

  const createPost = (req_num) => {
    console.log(req_num);
    Navigate("/user/drone/statusdronelast", {
      state: {
        drone_id: req_num,
      },
    });
  };
  const getdatadrone = (req_num, status1, caatcom, nbtccom) => {
    console.log(data)
    console.log(req_num);
    Navigate("/user/drone/datadrone", {
      state: {
        drone_id: req_num,
        status: status1,
        href: window.location.pathname,
        caatcom: caatcom,
        nbtccom: nbtccom,
      },
    });
  };
  const { state } = useLocation();
  const connectremoteid = (droneids, remoteids) => {
    try {
      const checkundefine = AuthServiceV2.connectremote(droneids, remoteids);
      if (checkundefine != null) {
        checkundefine
          .then((res) => {
            console.log(res);
            // window.location.reload(false);
          })
          .catch((error) => {
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });
          });
      }
    } catch (err) {
      console.log("Error");
    }
  };
  const Disconnectremoteid = (drone_id, remoteid_id) => {
    const checkundefine = AuthServiceV2.disconnectRemoteID(
      drone_id,
      remoteid_id
    );
    if (checkundefine != null) {
      checkundefine
        .then((res) => {
          console.log(res);

          // window.location.reload(false);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  const DeleteRemoteid = (remoteid_id) => {
    console.log(remoteid_id);
    const checkundefine = AuthServiceV2.removeremote(remoteid_id);
    if (checkundefine != null) {
      checkundefine
        .then((res) => {
          setShowRemoveRemote(false);
          console.log(res);
          window.location.reload(false);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  const payment = () => {
    const checkpayment = AuthServiceV2.PaymentDemo(droneidPay);
    if (checkpayment != null) {
      checkpayment
        .then((res) => {
          setShowPayment(false);
          console.log(res);
          window.location.reload(false);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  useEffect(() => {
    const check = AuthServiceV2.getoperatordrone();
    //console.log(check);
    if (check != null) {
      check
        .then((response) => {
          //console.log(response);
          if (response.data.dronedata === "No drone registered") {
            setShownoregisdrone(true);
            setTimeout(() => {
              setShownoregisdrone(false);
              Navigate("/user/drone/regisDrone");
            }, 2000);

            console.log("yes");
            setTimeout(() => {
              setLoading(false);
            }, 500);
          } else {
            //console.log("Drone", response.data.dronedata);
            setData(response.data.dronedata);

            setTimeout(() => {
              setLoading(false);
            }, 500);
          }
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
    const check2 = AuthServiceV2.getoperatorremote();
    if (check2 != null) {
      check2
        .then((response) => {
          //console.log(response);
          if (response.data.dronedata === "No reomte id registered") {
            // setTimeout(() => {
            //   Navigate("/user/drone/regisremote");
            // }, 2000);
          } else {
            setRemoteDrone(response.data.dronedata);
          }
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  }, []);

  const [searchValueDrone, setSeachValueDrone] = useState([
    "drone_req_num",
    "brand_model",
  ]);
  const [droneData, setDroneData] = useState([]);
  const [startArrDrone, setStartArrDrone] = useState(0);
  const handleDroneChange = (newPortion, startarr) => {
    console.log(newPortion);
    setDroneData(newPortion);
    setStartArrDrone(startarr);
  };

  const [searchValueRemote, setSeachValueRemote] = useState([
    "remoteid_nickname",
    "remoteid_serial_number",
  ]);
  const [remoteData, setRemoteData] = useState([]);
  const [startArrRemote, setStartArrRemote] = useState(0);
  const handleRemoteChange = (newPortion, startarr) => {
    console.log(newPortion);
    setRemoteData(newPortion);
    setStartArrRemote(startarr);
  };
  const [globalFilter, setGlobalFilter] = useState(null);
  const renderHeader = () => {
    return (
      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
        <h4 className="m-0"> </h4>
        <IconField iconPosition="left">
          <InputText
            style={{ width: "auto" }}
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            placeholder="🔍  ค้นหา..."
          />
        </IconField>
      </div>
    );
  };
  const renderHeaderRemote = () => {
    return (
      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
        <h4 className="m-0"> </h4>
        <IconField iconPosition="left">
          <InputText
            style={{ width: "auto" }}
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            placeholder="🔍  ค้นหา..."
          />
        </IconField>
      </div>
    );
  };
  const header = renderHeader();
  const headerRemote = renderHeaderRemote();
  const Body_number = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <MdDateRange /> */}
        <div style={{ marginLeft: "2px" }}> {data.drone_req_num}</div>
        {/* <div style={{ marginLeft: "2px" }}>   {`${data.registration_date.substring(0, 10)}` + " " + `${data.registration_date.substring(11, 16)}`}</div> */}
      </div>
    );
  };
  const Body_Regist_Date = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <MdDateRange />
        {/* <div style={{ marginLeft: "2px" }}> {data.drone_req_num}</div> */}
        <div style={{ marginLeft: "2px" }}>
          {" "}
          {`${data.registration_date.substring(0, 10)}` +
            " " +
            `${data.registration_date.substring(11, 16)}`}
        </div>
      </div>
    );
  };
  const Body_num_remote = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ textAlign: "left" }}>
          {/* <FaUserAstronaut />  {data.owner} */}
          {/* <br /> */}
          {data.remoteid_id}
        </div>
      </div>
    );
  };
  const Body_drone_remote_brand = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ textAlign: "left" }}>
          {/* <FaUserAstronaut />  {data.owner} */}
          {/* <br /> */}
          {data.remoteid_serial_number}
        </div>
      </div>
    );
  };
  const Body_remote_connect = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {data.drone_id !== null ? (
          <td>
            {data.drone_id}- {data.drone_brand_model}
          </td>
        ) : (
          <td>-</td>
        )}
      </div>
    );
  };
  const Body_cancle_remote = (data) => {
    return (
      <>
        <td
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <div
            onClick={() => {
              // Disconnectremoteid(item)
              setShowRemoveRemote(true);
              setSelectedItemsB([data.remoteid_id]);
            }}
            className="custom-btn btnCancel"
            style={{ fontSize: "16px" }}
          >
            X
          </div>
        </td>
      </>
    );
  };
  const Body_drone_remote_name = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ textAlign: "left" }}>
          {/* <FaUserAstronaut />  {data.owner} */}
          {/* <br /> */}
          {data.remoteid_nickname}
        </div>
      </div>
    );
  };
  const Body_owner_brand = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ textAlign: "left" }}>
          {/* <FaUserAstronaut />  {data.owner} */}
          {/* <br /> */}
          <GiDeliveryDrone /> {data.brand_model}
        </div>
      </div>
    );
  };
  const Body_Status = (data) => {
    return (
      <div style={{ justifyContent: "center", display: "flex" }}>
        <User_Drone_Status status={data.regis_status_text} />
        {/* <Regulator_Status status={data.caat} style={{width:"80%"}}/> */}
      </div>
    );
  };
  const Body_payment = (data) => {
    return (
      <div>
        {data.regis_status_text === "ชำระค่าพิจารณาคำขอ" ? (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              setdroneidPay(data.drone_id);
              setShowPayment(true);
            }}
          >
            <MdOutlinePayments
              style={{ color: "green", width: "30px", height: "30px" }}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };
  const Body_Information = (data) => {
    return (
      <div style={{ justifyContent: "center", display: "flex" }}>
        {(data.connect_rid === 1 && data.regis_status_text != "-") ||
        (data.connect_rid != 1 && data.regis_status_text != "-") ? (
          <>
            <>
              <a
                className="custom-link"
                onClick={() => {
                  getdatadrone(
                    data.drone_id,
                    data.regis_status_text,
                    data.caat_comment,
                    data.nbtc_comment
                  );
                }}
              >
                {data.regis_status_text === "รอแก้ไข" ||
                data.regis_status_text === "ร่างเอกสาร" ? (
                  <OverlayTrigger
                    placement="top" // You can adjust the placement: "top", "right", "bottom", "left"
                    overlay={<Tooltip id="edit doc">Edit</Tooltip>}
                  >
                    <div>
                      <img
                        alt="edit"
                        src={edits}
                        style={{ height: "36px", width: "36px" }}
                      />
                      <sup
                        style={{
                          color: "red",
                          top: "-10px",
                          right: "5px",
                          fontSize: "16px",
                        }}
                      >
                        !
                      </sup>
                    </div>
                  </OverlayTrigger>
                ) : (
                  <img
                    alt="edit"
                    src={docgif}
                    style={{ height: "36px", width: "36px" }}
                  />
                )}
              </a>
            </>
          </>
        ) : (
          <img
            alt="cancle"
            src={cancel}
            style={{ height: "36px", width: "36px" }}
          ></img>
        )}
      </div>
    );
  };
  const Body_RemoteID = (data) => {
    return (
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        {data.connect_rid >= 0 &&
        data.built_in_rid !== 1 &&
        data.caat_ap >= 4 &&
        data.nbtc_ap >= 4 ? (
          <>
            <select
              onChange={(e) => {
                console.log(e.target.value);
                if (e.target.value === "disconnect") {
                } else {
                  setSelectedItemsA([
                    `${parseInt(data.drone_id)}`,
                    `${parseInt(e.target.value)}`,
                    `${data.brand_model}`,
                  ]);
                  if (parseInt(e.target.value) !== 0) {
                    setShowConfirmConnect(true);
                  }
                }
              }}
              style={{
                height: "100%",
                width: "100%",
                fontFamily: "kanit",
                fontSize: "16px",
                border: "1px solid",
                borderRadius: "10px",
                backgroundColor: "white",
                paddingLeft: "15px",
              }}
            >
              <option value="disconnect" hidden>
                --Please choose a Remote ID--
              </option>
              {remoteDrone.map((drone) => {
                if (drone.drone_id === null) {
                  console.log(drone.remoteid_id);
                  return (
                    <option key={drone.remoteid_id} value={drone.remoteid_id}>
                      {drone.remoteid_nickname} ({drone.remoteid_serial_number})
                    </option>
                  );
                } else {
                  if (parseInt(data.drone_id) === parseInt(drone.drone_id)) {
                    return (
                      <option
                        selected
                        disabled
                        key={drone.remoteid_id}
                        value={drone.remoteid_id}
                        style={{ color: "green" }}
                      >
                        {drone.remoteid_nickname} (
                        {drone.remoteid_serial_number})
                      </option>
                    );
                  } else {
                    return (
                      <option
                        disabled
                        key={drone.remoteid_id}
                        value={drone.remoteid_id}
                        style={{ color: "red" }}
                      >
                        {drone.remoteid_nickname} (
                        {drone.remoteid_serial_number})
                      </option>
                    );
                  }
                }
              })}
            </select>
            &nbsp;&nbsp;&nbsp;
            {remoteDrone.map((drone) => {
              console.log(drone);
              if (drone.drone_id === null) {
              } else {
                if (parseInt(data.drone_id) === parseInt(drone.drone_id)) {
                  console.log(drone.remoteid_serial_number);
                  return (
                    <OverlayTrigger
                      placement="top" // You can adjust the placement: "top", "right", "bottom", "left"
                      overlay={
                        <Tooltip id="tooltip-disconnect">
                          Disconnect the drone
                        </Tooltip>
                      }
                    >
                      <div
                        onClick={() => {
                          setShowRemoveConnect(true);
                          setSelectedItemsB([drone.remoteid_id, data.drone_id]);
                        }}
                      >
                        <img
                          src={disconnect}
                          alt="disconnect"
                          style={{ width: "40px", cursor: "pointer" }}
                        />
                      </div>
                    </OverlayTrigger>
                  );
                }
              }
            })}
          </>
        ) : null}
        {data.built_in_rid === 1 ? <>Built-in Remote ID</> : null}
        {data.built_in_rid === 0 && (data.caat_ap < 1 || data.nbtc_ap < 1) ? (
          <img
            alt="cancle"
            src={cancel}
            style={{ height: "36px", width: "36px" }}
          ></img>
        ) : null}
      </div>
    );
  };

  console.log(remoteDrone);
  console.log(data);
  function filtered_Drone(data) {
    console.log(data);
    const filteredData = data.filter(
      (item) =>
        item.brand_model
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.drone_req_num
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.registration_date
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join(""))
    );
    return filteredData;
  }
  function filtered_Remote(data) {
    console.log(data);
    const filteredData = data.filter(
      (item) =>
        item.remoteid_nickname
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.remoteid_serial_number
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.remoteid_id === parseInt(globalFilter)
    );
    return filteredData;
  }

  const sortOrder = [
    "รอแก้ไข",
    "ชำระค่าพิจารณาคำขอ",
    "ตรวจสอบการชำระเงิน",
    "อยู่ระหว่างการพิจารณา",
    "อนุมัติ",
  ];
  const customSort = (event) => {
    const value = [...event.data]; // Clone the array to avoid modifying the original data
    value.sort((a, b) => {
      const value1 = a[event.field];
      const value2 = b[event.field];
      console.log(value2);
      const index1 = sortOrder.indexOf(value1);
      const index2 = sortOrder.indexOf(value2);

      return (index1 - index2) * event.order;
    });
    console.log(value);
    return value;
  };
  return (
    <>
      {loading === true ? (
        <>
          <div className="form-section">
            <div className="loading-container" style={{ height: "20vh" }}>
              {" "}
              <Spinner animation="border" variant="secondary" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="container-main">
            <div className="table-card-header">
              <h4 className="header-main" style={{ color: "white" }}>
                {t('statusdrone.main')}
              </h4>
            </div>
            {/* <Table striped bordered={false} hover className="table-main">
              <thead>
                <tr style={{ paddingTop: "20px", height: "80px" }}>
                  <th>เลขที่คำขอ</th>
                  <th>แบรนด์-รุ่น</th>
                  <th style={{ width: "20%" }}>สถานะการทำรายการ</th>
                  <th>วันที่ขอลงทะเบียน</th>
                  <th style={{ width: "15%" }}>เชื่อมต่อ RemoteID</th>
                  <th>ตรวจสอบข้อมูล</th>
                  <th>ชำระค่าบริการ</th>
                </tr>
              </thead>
              {droneData.map((item, index) => {
                return (
                  <tbody key={startArrDrone + index}>
                    <tr>
                      <td>
                        <p style={{ color: "black" }}>{item.drone_req_num}</p>
                        
                      </td>
                      <td>{item.brand_model}</td>

                      <td>
                        <User_Drone_Status status={item.regis_status_text} />
                      </td>

                      <td>{item.registration_date}</td>
                      <td>
                        {item.connect_rid >= 0 &&
                        item.built_in_rid !== 1 &&
                        item.caat_ap >= 4 &&
                        item.nbtc_ap >= 4 ? (
                          <>
                            <select
                              onChange={(e) => {
                                setSelectedItemsA([
                                  `${parseInt(item.drone_id)}`,
                                  `${parseInt(e.target.value)}`,
                                  `${item.brand_model}`,
                                ]);
                                if (parseInt(e.target.value) !== 0) {
                                  setShowConfirmConnect(true);
                                }
                              }}
                              style={{
                                height: "100%",
                                width: "100%",
                                fontSize: "28px",
                                border: "1px solid",
                                borderRadius: "10px",
                                backgroundColor: "white",
                                paddingLeft: "15px",
                              }}
                            >
                              <option value="0"></option>
                              {remoteDrone.map((drone) => {
                                if (drone.drone_id === null) {
                                  return (
                                    <option
                                      key={drone.remoteid_id}
                                      value={drone.remoteid_id}
                                      style={{ color: "green" }}
                                    >
                                      {drone.remoteid_nickname} (
                                      {drone.remoteid_serial_number})
                                    </option>
                                  );
                                } else {
                                  if (
                                    parseInt(item.drone_id) ===
                                    parseInt(drone.drone_id)
                                  ) {
                                    return (
                                      <option
                                        selected
                                        disabled
                                        key={drone.remoteid_id}
                                        value={drone.remoteid_id}
                                        style={{ color: "red" }}
                                      >
                                        {drone.remoteid_nickname} (
                                        {drone.remoteid_serial_number})
                                      </option>
                                    );
                                  } else {
                                    return (
                                      <option
                                        disabled
                                        key={drone.remoteid_id}
                                        value={drone.remoteid_id}
                                        style={{ color: "red" }}
                                      >
                                        {drone.remoteid_nickname} (
                                        {drone.remoteid_serial_number})
                                      </option>
                                    );
                                  }
                                }
                              })}
                            </select>
                          </>
                        ) : null}
                        {item.built_in_rid === 1 ? <>Built-in Remote</> : null}
                        {item.built_in_rid === 0 &&
                        (item.caat_ap < 1 || item.nbtc_ap < 1) ? (
                          <img
                            alt="cancle"
                            src={cancel}
                            style={{ height: "36px", width: "36px" }}
                          ></img>
                        ) : null}
                      </td>
                      <td>
                        {(item.connect_rid === 1 &&
                          item.regis_status_text != "-") ||
                        (item.connect_rid != 1 &&
                          item.regis_status_text != "-") ? (
                          <>
                            <>
                              <a
                                className="custom-link"
                                onClick={() => {
                                  getdatadrone(
                                    item.drone_id,
                                    item.regis_status_text
                                  );
                                }}
                              >
                                <FcDocument />
                              </a>
                            </>
                            
                          </>
                        ) : (
                          <img
                            alt="cancle"
                            src={cancel}
                            style={{ height: "36px", width: "36px" }}
                          ></img>
                        )}
                      </td>
                      <td>
                        {item.regis_status_text === "ชำระค่าพิจารณาคำขอ" ? (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setdroneidPay(item.drone_id);
                              setShowPayment(true);
                            }}
                          >
                            <MdOutlinePayments style={{ color: "green" }} />
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  </tbody>
                );
              })}
            </Table> */}
            {/* <PaginationS
              data={data}
              onPortionChange={handleDroneChange}
              searchValue={searchValueDrone}
            /> */}
            <br />
            <DataTable
              value={globalFilter ? filtered_Drone(data) : data}
              paginator
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              rows={5}
              rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
              header={header}
              emptyMessage="ไม่มีข้อมูล"
              tableStyle={{ minWidth: "50rem" }}
              style={{ fontFamily: "Kanit" }}
            >
              <Column
                header={t('statusdrone.number')}
                body={Body_number}
                field={`drone_req_num`}
                sortable
                filterField="drone_req_num"
                dataType="date"
                bodyStyle={{ alignItems: "center", textAlign: "center" }}
                style={{ width: "14%" }}
              ></Column>
              <Column
                header={t('statusdrone.brandmodel')}
                body={Body_owner_brand}
                field={"owner" && "brand_model"}
                sortable
                bodyStyle={{ alignItems: "center", textAlign: "center" }}
                style={{ width: "15%" }}
              ></Column>

              <Column
                header={t('statusdrone.status')}
                body={Body_Status}
                field="regis_status_text"
                sortable
                sortFunction={customSort}
                bodyStyle={{ textAlign: "center" }}
                style={{ width: "15%" }}
              ></Column>
              <Column
                header={t('statusdrone.dateregis')}
                body={Body_Regist_Date}
                field={`registration_date`}
                sortable
                filterField="registration_date"
                bodyStyle={{ textAlign: "center" }}
                style={{ width: "14%" }}
              ></Column>
              <Column
                header={t('statusdrone.connectRID')}
                body={Body_RemoteID}
                field={`built_in_rid`}
                sortable
                filterField="built_in_rid"
                bodyStyle={{ textAlign: "center" }}
                style={{ width: "20%" }}
              ></Column>

              <Column
                header={t('statusdrone.checkdata')}
                field={"connect_rid"}
                body={Body_Information}
                sortable
                sortFunction={customSort}
                bodyStyle={{ textAlign: "center" }}
                style={{ width: "12%" }}
              ></Column>
              <Column
                header={t('statusdrone.payservice')}
                //field={"connect_rid"}
                body={Body_payment}
                //sortable
                //sortFunction={customSort}
                bodyStyle={{ textAlign: "center" }}
                style={{ width: "11%" }}
              ></Column>
            </DataTable>
          </div>

          <div className="container-main">
            {/* <h2 className="header-main">สถานะ Remote ID</h2> */}
            <div className="table-card-header">
              <h4 className="header-main" style={{ color: "white" }}>
                {t('statusdrone.mainRemote')}
              </h4>
            </div>

            <br />
            <DataTable
              value={globalFilter ? filtered_Remote(remoteDrone) : remoteDrone}
              paginator
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              rows={5}
              rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
              header={headerRemote}
              emptyMessage="ไม่มีข้อมูล"
              tableStyle={{ minWidth: "50rem" }}
              style={{ fontFamily: "Kanit" }}
            >
              {/* <Column
                header="หมายเลข Remote ID"
                body={Body_num_remote}
                field={`remoteid_id`}
                sortable
                filterField="remoteid_id"
                bodyStyle={{ alignItems: "center", textAlign: "center" }}
                style={{ width: "12%" }}
              ></Column> */}
              <Column
                header={t('statusdrone.numberRemote')}
                body={Body_drone_remote_brand}
                field={"remoteid_serial_number"}
                sortable
                filterField="remoteid_serial_number"
                bodyStyle={{ alignItems: "center", textAlign: "center" }}
                style={{ width: "15%" }}
              ></Column>

              <Column
                header={t('statusdrone.nameRemote')}
                body={Body_drone_remote_name}
                field="remoteid_nickname"
                sortable
                filterField="remoteid_nickname"
                bodyStyle={{ textAlign: "center" }}
                style={{ width: "15%" }}
              ></Column>
              <Column
                header={t('statusdrone.connectDrone')}
                body={Body_remote_connect}
                field={`drone_id`}
                sortable
                filterField="drone_id"
                bodyStyle={{ textAlign: "center" }}
                style={{ width: "15%" }}
              ></Column>
              <Column
                header={t('statusdrone.deleteRID')}
                body={Body_cancle_remote}
                // field={`drone_id`}
                // sortable
                // filterField="drone_id"
                bodyStyle={{ textAlign: "center" }}
                style={{ width: "20%" }}
              ></Column>
            </DataTable>
          </div>

          {/* vvvv Modal vvvv */}
          <Static_modal
            modalwaiting={modalToggle.modalwait}
            modalErr={modalToggle.modalErr}
            modalSuccess={modalToggle.modalSuccess}
            modalDenied={modalToggle.modalDenied}
            textBody={textBody}
            getHandle={handleClose_Modal}
          />
          <Modal
            show={checkEditReason}
            onHide={() => {
              setCurrentChoosing();
              setCheckEditReason(false);
            }}
            className="font-cen"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>ตรวจสอบจุดที่ต้องแก้ไข</Modal.Title>
            </Modal.Header>
            <Modal.Body>{comment}</Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setCurrentChoosing();
                  setCheckEditReason(false);
                }}
              >
                ยกเลิก
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  createPost(currnetChoosing);
                  setCurrentChoosing();
                }}
              >
                เข้าสู่หน้าแก้ไข
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={ShowPayment}
            onHide={() => {
              setShowPayment(false);
            }}
            className="font-cen"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>ชำระค่าบริการ</Modal.Title>
            </Modal.Header>
            <Modal.Body>ค่าบริการ200บาท</Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setCurrentChoosing();
                  setCheckEditReason(false);
                }}
              >
                ยกเลิก
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  payment();
                }}
              >
                ชำระค่าบริการ
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={showConfirmConnect}
            onHide={() => {
              setSelectedItemsA([]);
              setShowConfirmConnect(false);
            }}
            className="font-cen"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>ยืนยันการเชื่อมต่อ Remote ID</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <>
                {remoteDrone.find(
                  (remoteDrone) =>
                    parseInt(remoteDrone.drone_id) ===
                    parseInt(selectedItemsA[0])
                ) !== undefined ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <TbDrone style={{ fontSize: "50px", color: "green" }} />
                        <p style={{ textAlign: "center", color: "green" }}>
                          {selectedItemsA[0]}
                        </p>
                      </div>
                      <div
                        style={{
                          fontSize: "50px",
                          marginBottom: "15px",
                          color: "green",
                        }}
                      >
                        --------
                      </div>
                      <div>
                        <MdSettingsRemote
                          style={{ fontSize: "50px", color: "green" }}
                        />
                        <p style={{ textAlign: "center", color: "green" }}>
                          {" "}
                          {selectedItemsA[1]}
                        </p>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <h5>
                        โดรนที่คุณกำลังจะเปลี่ยนการเชื่อมต่อได้เชื่อมอยู่กับรีโมทอื่นอยู่
                        คุณยืนยันที่จะเชื่อมต่อ โดรนรหัส {selectedItemsA[0]}{" "}
                        กับรีโมทรหัส {selectedItemsA[1]} คุณยืนยันหรือไม่
                      </h5>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <TbDrone style={{ fontSize: "50px", color: "green" }} />
                        <p style={{ textAlign: "center", color: "green" }}>
                          {selectedItemsA[0]}
                        </p>
                      </div>
                      <div
                        style={{
                          fontSize: "50px",
                          marginBottom: "15px",
                          color: "green",
                        }}
                      >
                        --------
                      </div>
                      <div>
                        <MdSettingsRemote
                          style={{ fontSize: "50px", color: "green" }}
                        />
                        <p style={{ textAlign: "center", color: "green" }}>
                          {" "}
                          {selectedItemsA[1]}
                        </p>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <h5>
                        คุณยืนยันที่จะเชื่อมต่อ โดรนรหัส {selectedItemsA[0]}{" "}
                        กับรีโมทรหัส {selectedItemsA[1]}
                      </h5>
                    </div>
                  </>
                )}
              </>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setSelectedItemsA([]);
                  setShowConfirmConnect(false);
                }}
              >
                ยกเลิก
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  const objectToRemove = remoteDrone.find(
                    (remoteDrone) =>
                      parseInt(remoteDrone.drone_id) ===
                      parseInt(selectedItemsA[0])
                  );

                  if (objectToRemove) {
                    objectToRemove.drone_id = null;
                    objectToRemove.drone_brand_model = null;
                  }

                  const objectToUpdate = remoteDrone.find(
                    (remoteDrone) =>
                      parseInt(remoteDrone.remoteid_id) ===
                      parseInt(selectedItemsA[1])
                  );

                  if (objectToUpdate) {
                    objectToUpdate.drone_id = `${selectedItemsA[0]}`;
                    objectToUpdate.drone_brand_model = `${selectedItemsA[2]}`;
                  }

                  connectremoteid(
                    parseInt(selectedItemsA[0]),
                    parseInt(selectedItemsA[1])
                  );
                  setSelectedItemsA([]);
                  setShowConfirmConnect(false);
                }}
              >
                ยืนยัน
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={showRemoveConnect}
            onHide={() => {
              setSelectedItemsB([]);
              setShowRemoveConnect(false);
            }}
            className="font-cen"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>ยกเลิกการเชื่อมต่อ RemoteID</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <TbDrone style={{ fontSize: "50px", color: "red" }} />
                    <p style={{ textAlign: "center", color: "red" }}>
                      {selectedItemsB[0]}
                    </p>
                  </div>
                  <div
                    style={{
                      fontSize: "50px",
                      marginBottom: "15px",
                      color: "red",
                    }}
                  >
                    ----x----
                  </div>
                  <div>
                    <MdSettingsRemote
                      style={{ fontSize: "50px", color: "red" }}
                    />
                    <p style={{ textAlign: "center", color: "red" }}>
                      {" "}
                      {selectedItemsB[1]}
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <h5>
                    คุณยืนยันที่จะยกเลิกเชื่อมต่อ โดรนรหัส {selectedItemsB[0]}{" "}
                    กับรีโมทรหัส {selectedItemsB[1]}
                  </h5>
                </div>
              </>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setSelectedItemsB([]);
                  setShowRemoveConnect(false);
                }}
              >
                ยกเลิก
              </Button>
              <Button
                variant="primary"
                onClick={(e) => {
                  // DeleteRemoteid(parseInt(selectedItemsB[0]));
                  Disconnectremoteid(
                    parseInt(selectedItemsB[1]),
                    parseInt(selectedItemsB[0])
                  );
                  // console.log(selectedItemsB)
                  const objectToRemove = remoteDrone.find(
                    (remoteDrone) =>
                      parseInt(remoteDrone.remoteid_id) ===
                      parseInt(selectedItemsB[0])
                  );

                  if (objectToRemove) {
                    objectToRemove.drone_id = null;
                    objectToRemove.drone_brand_model = null;
                    setRemoteDrone([...remoteDrone]);
                  }

                  setSelectedItemsA([""]);
                  setSelectedItemsB([]);
                  setShowRemoveConnect(false);
                }}
              >
                ยืนยัน
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showRemoveRemote}
            onHide={() => {
              setSelectedItemsB([]);
              setShowRemoveRemote(false);
            }}
            className="font-cen"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>ปลดการครอบครอง Remote ID</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <MdSettingsRemote
                      style={{ fontSize: "50px", color: "red" }}
                    />
                    <p style={{ textAlign: "center", color: "red" }}>
                      {" "}
                      {selectedItemsB[1]}
                    </p>
                  </div>
                </div>
              </>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setSelectedItemsB([]);
                  setShowRemoveRemote(false);
                }}
              >
                ยกเลิก
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  DeleteRemoteid(parseInt(selectedItemsB[0]));
                  // Disconnectremoteid(
                  //   parseInt(selectedItemsB[1]),
                  //   parseInt(selectedItemsB[0])
                  // );
                  // console.log(selectedItemsB)
                  const objectToRemove = remoteDrone.find(
                    (remoteDrone) =>
                      parseInt(remoteDrone.remoteid_id) ===
                      parseInt(selectedItemsB[0])
                  );

                  if (objectToRemove) {
                    objectToRemove.drone_id = null;
                    objectToRemove.drone_brand_model = null;
                    setRemoteDrone([...remoteDrone]);
                  }
                  setSelectedItemsB([]);
                  setShowRemoveConnect(false);
                }}
              >
                ยืนยัน
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={shownoregisdrone}
            onHide={() => {
              setShownoregisdrone(false);
            }}
            className="font-cen"
            centered
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>แจ้งเตือน</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <>
                <p style={{ color: "red" }}>คุณยังไม่ได้ขึ้นทะเบียนโดรน</p>
              </>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
}

export default StatusDrone;
